"use client";

import { SLFooter } from "@/components/layout/SLFooter";
import { SLNavigation } from "@/components/layout/SLNavigation";
import { SLHomeContact } from "@/components/sections/home/SLHomeContact";
import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import { useRef } from "react";
import SLLayoutGeneral from "./SLLayoutGeneral";

export function SLSubpageChrome({
  children,
  isWithoutContact,
}: {
  children: React.ReactNode;
  isWithoutContact?: boolean;
}) {
  const contactRef = useRef<HTMLDivElement | null>(null);

  return (
    <SLLayoutGeneral>
      <SLNavigation
        contentContainerMaxWidth="xl"
        contactRef={contactRef}
        disableEntryAnimation
      />

      <main>
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            mt: 4,
          }}
        >
          <Stack sx={{ zIndex: 3 }}>
            <article>{children}</article>

            {!isWithoutContact && (
              <section>
                <SLHomeContact contactRef={contactRef} />
              </section>
            )}
          </Stack>
        </Box>
      </main>

      <footer>
        <SLFooter />
      </footer>
    </SLLayoutGeneral>
  );
}
